import PrototypeInstance from "../helper/prototype-instance";
import { technicianEntity } from "../model/entity/technician-entity";

export function _fullName(technicianId: number): string {
  let technican = technicianEntity.query().find(technicianId);
  let name = "";
  if (technican) {
    if (technican.firstName && technican.firstName != null) {
      name += technican.firstName;
    }
    if (technican.lastName && technican.lastName != null) {
      name += " " + technican.lastName;
    }
    if (name != "") return name.trim();
  }
  return name;
}

export function _fullNameWithNickName(technicianId: number): string {
  let technican = technicianEntity.query().find(technicianId);
  let name = "";
  if (technican) {
    if (technican.firstName && technican.firstName != null) {
      name += technican.firstName;
    }
    if (technican.lastName && technican.lastName != null) {
      name += " " + technican.lastName;
    }
    if (technican.nickName && technican.nickName != null) {
      name += " (" + technican.nickName + ")";
    }
    if (name != "") return name.trim();
  }
  return name;
}

export function _getFullName(firstName: string, lastName: string): string {
  let name = "";
  if (firstName && firstName != null) {
    name += firstName;
  }
  if (lastName && lastName != null) {
    name += " " + lastName;
  }

  if (name != "") return name.trim();

  return name;
}

export function firstNameForSort(firstName: string) {
  let firstNameSort = "";
  if (firstName) firstNameSort += firstName;
  if (firstNameSort !== "") return firstNameSort.toLowerCase();
  return "";
}

export function lastNameForSort(lastName: any) {
  let lastNameSort = "";
  if (lastName) lastNameSort += lastName;
  if (lastNameSort != "") return lastNameSort.toLowerCase();
  return "";
}

export function getTechnicianSelfName(
  technicianId: any,
  firstName: string,
  lastName: string,
) {
  if (
    technicianId ===
    PrototypeInstance.globalProperties.$LoggedInUser.technicianId
  ) {
    return "You";
  } else {
    return _getFullName(firstName, lastName);
  }
}

export function initials(firstName: string, lastName: string) {
  let initials = "N/A";
  if (firstName && firstName != null) {
    initials = (firstName as string).charAt(0).toUpperCase();
  }
  if (lastName && lastName != null) {
    initials += (lastName as string).charAt(0).toUpperCase();
  }

  return initials;
}

export function fullNameForSort(firstName: string, lastName: string) {
  let name = "";
  if (firstName && firstName !== null) {
    name = firstName;
  }
  if (lastName && lastName != null) {
    name += " " + lastName;
  }

  if (name !== "") return name.toLowerCase().trim();
}

export function fullNameForSortWithNickName(
  firstName: string,
  lastName: string,
  nickName: string,
) {
  let name = "";
  if (firstName && firstName !== null) {
    name = firstName;
  }
  if (lastName && lastName != null) {
    name += " " + lastName;
  }

  if (nickName) {
    name += " " + nickName;
  }

  if (name !== "") return name.toLowerCase().trim();
}

export function id(technician: any) {
  return "@" + technician.fullName;
}

export function fullNameWithEmail(technicianId: number, email: string) {
  return `${_fullName(technicianId)} (${email})`;
}

export function getTechnicianFirstName(createdByTechnicianId: any) {
  if (createdByTechnicianId != null && createdByTechnicianId != 0) {
    let technician = technicianEntity
      .query()
      .find(createdByTechnicianId.toString());
    if (technician) return technician.firstName;
  }

  return "";
}

export function getTechnicianNameByPov(
  technicianId: any,
  lastModifiedByLoggedInUser: any,
  event: boolean = false,
): string {
  let technicianName: string = "";

  if (typeof technicianId == "string") {
    technicianId = parseInt(technicianId);
  }

  const loggedInTechnicianId =
    PrototypeInstance.globalProperties.$LoggedInUser.technicianId;

  if (event) {
    if (technicianId == loggedInTechnicianId) {
      if (lastModifiedByLoggedInUser) {
        return "yourself";
      } else {
        return "you";
      }
    }
  } else {
    if (technicianId == loggedInTechnicianId) {
      technicianName = "You";
    }
  }

  if (technicianId != loggedInTechnicianId) {
    let technician = technicianEntity
      .query()
      .where("technicianId", technicianId)
      .first();
    technicianName = technician != null ? technician.fullName : "";
  }

  return technicianName;
}

export function getTechnicianLastName(createdByTechnicianId: number) {
  if (createdByTechnicianId > 0) {
    let technician = technicianEntity
      .query()
      .find(createdByTechnicianId.toString());
    if (technician) return technician.lastName;
    return "";
  }

  return "";
}

export function getTechnicianThemeById(technicianId: number) {
  if (technicianId > 0) {
    let technician = technicianEntity.query().whereId(technicianId).first();
    if (technician) return technician.themeId;
  }

  return 1;
}
